<template>
  <div>
    <FITModal ref="deleteProviderModal" reference="modal" :title="$t('osm.provider.delete.header')" @click="onClickModalDelete">
      <div slot="body">
        <span v-html="$t('osm.provider.delete.confirmDelete', {providerCode: clickedRow.providerCode, providerChineseName: clickedRow.providerChineseName, providerEnglishName: clickedRow.providerEnglishName})"></span>
      </div>
    </FITModal>
    <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{$t('osm.provider.list.header')}}</h4>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-button variant="primary" size="md" @click="createProvider"><i class="fa fa-plus-circle mr-2"></i>{{ $t('osm.provider.create.header') }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" :actions="actions" vuexModule="Provider" searchAction="getProviderList" :columns="columns"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITSearchableTable, FITFormCard, FITAlert, FITModal } from '@/components'
export default {
  name: 'ProviderList',
  props: {
    alertContent: {
      type: String,
      default: null
    },
    alertVariant: {
      type: String,
      default: null
    }
  },
  mounted() {
    if (this.alertContent) {
      this.setAlert();
      this.$refs.alert.showAlert();
    }
  },
  methods: {
    setAlert() {
      if (this.alertContent) {
        Vue.set(this.alertParams, 'content', this.alertContent);
      }
      if (this.alertVariant) {
        Vue.set(this.alertParams, 'variant', this.alertVariant);
      }
    },
    createProvider() {
      this.$router.push({
        name: 'Create Provider'
      })
    },
    onRowSelected(val) {
      this.$router.push({
        name: 'Create Provider',
        params: { detail: val, providerHeader: this.$t('osm.provider.edit.header') }
      });
    },
    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('Provider/deleteProvider', this.clickedRow.ID).then((json) => {
        this.$refs.table.search();
        this.$refs.deleteProviderModal.closeModal();
        Vue.set(this, 'alertParams', { content: this.$t('general.deleteSuccess'), variant: 'success' });
        this.$refs.alert.showAlert();
      })
    },
  },
  data() {
    return {
      clickedRow: {
        providerCode: '',
        providerEnglishName: '',
        providerChineseName: ''
      },
      alertParams: {
        content: '<strong>Success</strong>',
        variant: 'success'
      },
      columns: [
        { key: 'providerCode', label: this.$t('osm.provider.providerCode'), sortable: true },
        {
          key: 'providerEnglishName',
          label: this.$t('osm.provider.list.providerName'),
          formatter: (row, key, item) => {
            return item.providerEnglishName + "</br>" + item.providerChineseName;
          },
          sortable: true
        },
        { key: 'brokerHotline', label: this.$t('osm.provider.list.brokerHotline'), sortable: true },
        { key: 'updateTime', label: this.$t('osm.provider.list.updateTime'), sortable: true },

      ],
      actions: [{
          text: this.$t('osm.provider.edit.header'),
          key: 'edit',
          callback: (key, row, instance) => {
            // Vue.set(this, 'clickedRow', row);
            this.$router.push({
              name: 'Create Provider',
              params: { detail: row, providerHeader: this.$t('osm.provider.edit.header') }
            });
          }
        },
        {
          text: this.$t('osm.provider.delete.header'),
          key: 'view',
          callback: (key, row, instance) => {
            Vue.set(this, 'clickedRow', row);
            this.$refs.deleteProviderModal.openModal();
          },
          class: 'text-danger'
        }
      ],
    }
  },
  components: {
    FITSearchableTable,
    FITFormCard,
    FITAlert,
    FITModal
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Provider/containers/ProviderList.vue